function PayModes() {
    return (
      <>
        <div className="font-bold text-lg mb-16">PayModes</div>
      </>
    );
  }
  
  export default PayModes;